var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.85 5.25c-5.503 0-9.964 4.46-9.964 9.963 0 2.48.91 4.747 2.41 6.491L4.47 26.53l1.06 1.06 4.824-4.823a9.92 9.92 0 0 0 6.495 2.41c5.502 0 9.962-4.46 9.962-9.963s-4.46-9.963-9.962-9.963Zm0 1.5a8.464 8.464 0 1 1-.002 16.926A8.464 8.464 0 0 1 16.85 6.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconSearch;